import axios from "axios";
import urlConfig from "../../../mixins/url";

export default {
  namespaced: true,
  state: {
    coolingTunnels: [],
    sizeSmall: 1,
    sizeBig: 2,
  },
  mutations: {
    //Synchroniczne
    setCoolingTunnels(state, data) {
      state.coolingTunnels = data;
    },
    updateCoolingTunnel(state, data) {
      state.coolingTunnels.filter((x) => x.id == data.id)[0] = data;
    },
    removeCoolingTunnel(state, id) {
      state.coolingTunnels = state.coolingTunnels.fillter((x) => x.id != id);
    },
  },
  actions: {
    //Asyncrhoniczne
    getCoolingTunnels(state) {
      var urlRoot = urlConfig.data().url;
      var url = `${urlRoot.serverUrl}${urlRoot.CoolingTunnel.Get}`;

      if (state.state.coolingTunnels.length == 0) {
        return new Promise((resolve, reject) => {
          axios
            .get(url)
            .then((result) => {
              result.data.data.forEach((x) => (x.isEdit = false));
              state.commit("setCoolingTunnels", result.data.data);
              resolve({});
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
  },
};
